import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ServiceStock } from '../service-stock.service';
import { FieldComponent } from '../field/field.component';
@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
}) 
export class PasswordComponent extends FieldComponent implements OnInit {

  @Input('maxLength') maxLength: number;
  @Input('minLength') minLength: number;
  @Input('hide') hide: boolean;
  
  constructor(services: ServiceStock) {
    super(services);
  }

  ngOnInit() {
    
  }

  getFieldInfo() {
    return (this.value == undefined) ? "" : this.value;
  }

  async validateValue(value, event = undefined): Promise<number> {
    var totalErrors: number = 0;
   
      totalErrors += this.onTextInput(value, event);
    
    return totalErrors;
  }

  onTextInput(value: string, event?): number {
    var totalErrors: number = 0;
    if (this.minLength && value.length < this.minLength) {
      this.setError("Minimum " + this.minLength + " characters are required");
      totalErrors++;
    } else if(this.maxLength && value.length > this.maxLength){
      this.setError("Maximum " + this.maxLength + " characters are allowed");
      totalErrors++;
    }
    else {
      this.clearError();
    }
    return totalErrors;
  }

}
